/*
 *   File : add-nominee-details.js
 *   Author : https://evoqins.com
 *   Description : Onboarding step  - Nominee Add page
 *   Integrations : react-toastify, date-fns
 *   Version : 1.0.0
 *   Date : 25-09-2022  
*/

import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie"

// *********** Components ***************//  
import { Icon } from "../../../Component/Icon";
import { PrimaryButton, TextButton } from "../../../Component/Buttons";
import { APIService } from "../../../Service";

// *********** Styles ***************//  
import styles from "../../../Style/Component/login.module.scss";
import Colors from "../../../Style/color.scss";
import { RadioGroup } from "../../../Component/Form-Elements";
import { AddNomineeCard } from "../../../Component/Cards";
import { differenceInYears, nextMonday } from "date-fns";
import { useSelector } from "react-redux";
import { _formatDateFormat, _getSignupProgress, _trackEvent } from "../../../Helper";

// *********** Assets ***************// 
import Delete from "../../../Assets/Images/KYC/delete.svg";
import { KycStatusModal } from "../../../Component/Modal";
import { Modal } from "bootstrap";
import Store from "../../../Store/store";


// *********** Custom Data ***************//
const YES_NO_OPTIONS = [
    {
        id: 1,
        display_name: "Yes"
    },
    {
        id: 2,
        display_name: "No"
    },
];

function AddNominee(props) {

    const navigate = useNavigate();
    //get general data from redux
    const GENERAL_DATA = useSelector((store) => store.Reducer.GENERAL_DATA);
    const PROGRESS_DATA = useSelector((store) => store.Reducer.SIGNUP_PROGRESS_DATA);
    const [generalData, setGeneralData] = useState(GENERAL_DATA);
    const [addNomineeSelect, setAddNomineeSelect] = useState(1);
    const [countryData, setCountryData] = useState(props.countryData);
    const [fetchNominee, setFetchNominee] = useState(false);
    const [nomineeVisibility, setNomineeVisibility] = useState(0);
    const [loading, setLoading] = useState(false);
    const [statusModal, setStatusModal] = useState(false);

    const [nomineeData, setNomineeData] = useState([
        {
            "id": crypto.randomUUID(),
            "nominee_id": null,
            "name": null,
            "relation_id": null,
            "relation": null,
            "dob": null,
            "allocation": null,
            "identity_proof_type": null,
            "identity_proof_number": null,

            "guardian_name": null,
            "guardian_relationship_id": null,
            "guardian_relationship": null,
            "guardian_id_proof_type": null,
            "guardian_id_proof_number": null,
            "guardian_address": {
                "address_line1": null,
                "address_line2": null,
                "state_id": null,
                "state_name": null,
                "city_id": null,
                "city": null,
                "pincode": null,
                "country_id": null,
                "country": null
            },
            "guardian_contact_detail": {
                "email": null,
                "country_code": null,
                "phone_number": null
            },


            "nominee_address": {
                "address_line1": null,
                "address_line2": null,
                "state_id": null,
                "state_name": null,
                "city_id": null,
                "city": null,
                "pincode": null,
                "country_id": null,
                "country": null,
            },
            "contact_detail": {
                "email": null,
                "country_code": null,
                "phone_number": null
            },
            "nominations_info_visibility": true,
        }
    ]);
    const [errorMessage, setErrorMessage] = useState([
        {
            "id": crypto.randomUUID(),
            "name_error": null,
            "relation_id_error": null,
            "dob_error": null,
            "allocation_error": null,

            "id_proof_no_error": null,
            "selected_proof_id_error": null,
            "mobile_number_error": null,
            "email_error": null,

            "guardian_name_error": null,
            "guardian_relationship_id_error": null,
            "guardian_pan_error": null,

            "nationality_error": null,
            "address_error": null,
            "address2_error": null,
            "state_error": null,
            "city_error": null,
            "pincode_error": null
        }
    ]);

    const screenViewLatch = useRef(false);

    // Screen view tracking
    useEffect(() => {
        if (screenViewLatch.current === false) {
            screenViewLatch.current = true;
            _trackEvent("screen_nominee_details_viewed", { screen: "nominee_details", flow: "onboarding" });
        }
    }, []);

    useEffect(() => {
        if (GENERAL_DATA) {
            setGeneralData(GENERAL_DATA);
            setNomineeVisibility(GENERAL_DATA?.nominations_info_visibility ? GENERAL_DATA?.nominations_info_visibility[0].id : 0);
        };
    }, [GENERAL_DATA]);

    useEffect(() => {
        let nominee_errors = [];
        if (PROGRESS_DATA?.kyc_data?.nominee?.length !== 0) {

            let nominee_list = PROGRESS_DATA.kyc_data?.nominee.map((nominee) => (
                {
                    ...nominee,
                    "id": crypto.randomUUID(),
                }
            ))
            setNomineeData(nominee_list);

            for (let nominee_count = 0; nominee_count < PROGRESS_DATA.kyc_data.nominee.length; nominee_count++) {
                let nominee_error = {
                    "id": crypto.randomUUID(),
                    "name_error": null,
                    "relation_id_error": null,
                    "dob_error": null,
                    "allocation_error": null,
                    "id_proof_no_error": null,
                    "selected_proof_id_error": null,
                    "mobile_number_error": null,
                    "email_error": null,

                    "guardian_name_error": null,
                    "guardian_relationship_id_error": null,
                    "guardian_pan_error": null,

                    "nationality_error": null,
                    "address_error": null,
                    "state_error": null,
                    "city_error": null,
                    "pincode_error": null

                };
                nominee_errors.push(nominee_error);
            }
            setErrorMessage(nominee_errors);


            if (PROGRESS_DATA?.kyc_data?.nominee[0].nominations_info_visibility) {
                setNomineeVisibility(PROGRESS_DATA.kyc_data.nominee[0].nominations_info_visibility);
            }

            setAddNomineeSelect(1);
        }
    }, [PROGRESS_DATA]);


    useEffect(() => {
        if (statusModal === true) {
            let kyc_status = new Modal(document.getElementById('kyc-status-modal'));
            kyc_status.show();
        }
    }, [statusModal]);


    //handle nominee select
    const _handleChangeNomineeVisibility = (id) => {
        setNomineeVisibility(id);
    };


    //handle nominee select
    const _handleAddNominee = (id) => {
        _trackEvent("nominee_selection_changed", { screen: "nominee_details", flow: "onboarding" });
        setAddNomineeSelect(id);
    };

    // remove nominee from list
    const _handleRemoveNominee = (id) => {

        let updated_nominee = [...nomineeData];
        updated_nominee = updated_nominee.filter((item) => item.id !== id);
        setNomineeData(updated_nominee);

        // Clearing err object related to nominee  
        let updated_err_message = [...errorMessage];
        updated_err_message = updated_err_message.filter((item) => item.id !== id);
        setErrorMessage(updated_err_message);
    };

    //validating input field 
    const _validateNomineeData = (nominees, selected_id_proof_id, selected_guardian_id_proof_id) => {

        // Setting err array to scroll to first err input
        let error_inputs = [];
        let is_minor_nominee = false;
        let error_list = [...errorMessage];
        let validation_status = true;
        let validate_email = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
        let validate_pan = /^[A-Z]{3}P[A-Z]{1}\d{4}[A-Z]{1}$/; // validation of PAN

        for (let i = 0; i < nominees.length; i++) {
            const nominee_data = nominees[i];

            if (nominee_data?.dob != null) {
                is_minor_nominee = differenceInYears(new Date(), _formatDateFormat(nominee_data?.dob)) < 18;
            } else {
                is_minor_nominee = false;
            }

            if (nominee_data.name === null) {
                error_list[i].name_error = "Provide the nominee full name";
                validation_status = false;
                error_inputs.push(`name-${i}`);
            } else {
                error_list[i].name_error = null;
            }

            if (nominee_data.relation_id === null) {
                error_list[i].relation_id_error = 'Please declare the relationship with the nominee';
                validation_status = false;
                error_inputs.push(`relation-${i}`);
            } else {
                error_list[i].relation_id_error = '';
            }

            if (nominee_data.dob === null) {
                error_list[i].dob_error = "Please provide the nominee's date of birth";
                validation_status = false;
                error_inputs.push(`dob-${i}`);
            } else {
                error_list[i].dob_error = '';
            }

            // nominee_data.allocation = number or empty string
            if (nominee_data.allocation === null) {
                error_list[i].allocation_error = 'Please specify the allocation details';
                validation_status = false;
                error_inputs.push(`allocation-${i}`);
            } else {
                error_list[i].allocation_error = '';
            }


            if (is_minor_nominee == false) {

                if (nominee_data.identity_proof_type === null) {
                    error_list[i].selected_proof_id_error = "Please select the proof";
                    validation_status = false;
                    error_inputs.push(`id-proof-type-${i}`);
                } else {
                    error_list[i].selected_proof_id_error = '';
                }

                if (nominee_data.identity_proof_number === null) {
                    error_list[i].id_proof_no_error = "Please provide ID proof number";
                    validation_status = false;
                    error_inputs.push(`id-proof-number-${i}`);
                } else if (nominee_data.identity_proof_type_name === "pan" && !validate_pan.test(nominee_data.identity_proof_number)) { // Pan Validation
                    error_list[i].id_proof_no_error = 'Please provide valid PAN ID';
                    validation_status = false;
                    error_inputs.push(`id-proof-number-${i}`);
                } else if (nominee_data.identity_proof_type_name === "aadhaar" && nominee_data.identity_proof_number.length < 4) { // Aadhaar Validation
                    error_list[i].id_proof_no_error = 'Please provide last 4 digit of Aadhaar';
                    validation_status = false;
                    error_inputs.push(`id-proof-number-${i}`);
                } else {
                    error_list[i].id_proof_no_error = '';
                }

            }

            //guardian validation
            if (is_minor_nominee === true) {
                if (nominee_data.guardian_name === null) {
                    error_list[i].guardian_name_error = "Please provide the guardian's full name in this field";
                    validation_status = false;
                    error_inputs.push(`guardian-name-${i}`);
                } else {
                    error_list[i].guardian_name_error = '';
                }

                if (nominee_data.guardian_relationship_id == null) {
                    error_list[i].guardian_relationship_id_error = 'Please select the relationship with the nominee from the list';
                    validation_status = false;
                    error_inputs.push(`guardian-relation-${i}`);
                } else {
                    error_list[i].guardian_relationship_id_error = '';
                }

                if (nominee_data.guardian_id_proof_type == null) {
                    error_list[i].guardian_id_type_error = 'Please select the ID proof';
                    validation_status = false;
                    error_inputs.push(`guardian-id-proof-type-${i}`);
                } else {
                    error_list[i].guardian_id_type_error = '';
                }

                if (nominee_data.guardian_id_proof_number == null) {
                    error_list[i].guardian_id_no_error = 'Please provide the ID proof no';
                    validation_status = false;
                    error_inputs.push(`guardian-id-proof-number-${i}`);
                    // 
                } else if (nominee_data.guardian_id_proof_type_name === "pan" && !validate_pan.test(nominee_data.guardian_id_proof_number)) {  // Pan Validation
                    error_list[i].guardian_id_no_error = 'Please provide valid PAN ID';
                    validation_status = false;
                    error_inputs.push(`guardian-id-proof-number-${i}`);
                } else if (nominee_data.guardian_id_proof_type_name === "aadhaar" && nominee_data.guardian_id_proof_number.length < 4) {  // Aadhaar Validation
                    error_list[i].guardian_id_no_error = 'Please provide last 4 digit of Aadhaar';
                    validation_status = false;
                    error_inputs.push(`guardian-id-proof-number-${i}`);
                } else {
                    error_list[i].guardian_id_no_error = '';
                }


                if (nominee_data.guardian_contact_detail.phone_number === null) {
                    error_list[i].guardian_mobile_number_error = "Please provide mobile number";
                    validation_status = false;
                    error_inputs.push(`guardian-phone-number-${i}`);
                } else if (nominee_data.guardian_contact_detail.country_code === "+91" && nominee_data.guardian_contact_detail.phone_number.length !== 10) {
                    error_list[i].guardian_mobile_number_error = "Please provide valid mobile number";
                    validation_status = false;
                    error_inputs.push(`guardian-phone-number-${i}`);
                } else {
                    error_list[i].guardian_mobile_number_error = '';
                }


                if (nominee_data.guardian_contact_detail.email == null) {
                    error_list[i].guardian_email_error = "Please provide email";
                    validation_status = false;
                    error_inputs.push(`gurdian-email-${i}`);
                } else if (!validate_email.test(nominee_data.guardian_contact_detail.email)) {
                    error_list[i].guardian_email_error = "Please provide valid email";
                    validation_status = false;
                    error_inputs.push(`gurdian-email-${i}`);
                } else {
                    error_list[i].guardian_email_error = "";
                }

                /// Address validation
                if (nominee_data.has_same_address === false) {

                    if (nominee_data.guardian_address.country === null) {
                        error_list[i].nationality_error = "Please provide country";
                        validation_status = false;
                        error_inputs.push(`nationality-${i}`);
                    } else {
                        error_list[i].nationality_error = "";
                    }

                    if (nominee_data.guardian_address.address_line1 === null) {
                        error_list[i].address_error = "Please provide address";
                        validation_status = false;
                        error_inputs.push(`address-${i}`);
                    } else {
                        error_list[i].address_error = "";
                    }

                    if (nominee_data.guardian_address.address_line2 === null) {
                        error_list[i].address2_error = "Please provide address";
                        validation_status = false;
                        error_inputs.push(`address2-${i}`);
                    } else {
                        error_list[i].address2_error = "";
                    }

                    if (nominee_data.guardian_address.state_name === null) {
                        error_list[i].state_error = "Please select state";
                        validation_status = false;
                        error_inputs.push(`state-${i}`);
                    } else {
                        error_list[i].state_error = "";
                    }

                    if (nominee_data.guardian_address.city === null) {
                        error_list[i].city_error = "Please select city";
                        validation_status = false;
                        error_inputs.push(`city-${i}`);
                    } else {
                        error_list[i].city_error = "";
                    }

                    if (nominee_data.guardian_address.pincode === null) {
                        error_list[i].pincode_error = "Please provide pincode";
                        validation_status = false;
                        error_inputs.push(`pincode-${i}`);
                    } else {
                        error_list[i].pincode_error = "";
                    }
                }

            }


            if (is_minor_nominee === false) {
                if (nominee_data.contact_detail.phone_number === null) {
                    error_list[i].mobile_number_error = "Please provide mobile number";
                    validation_status = false;
                    error_inputs.push(`phone-number-${i}`);
                } else if (nominee_data.contact_detail.country_code === "+91" && nominee_data.contact_detail.phone_number.length !== 10) {
                    error_list[i].mobile_number_error = "Please provide valid mobile number";
                    validation_status = false;
                    error_inputs.push(`phone-number-${i}`);
                } else {
                    error_list[i].mobile_number_error = '';
                }

                if (nominee_data.contact_detail.email === null) {
                    error_list[i].email_error = "Please provide email ID";
                    validation_status = false;
                    error_inputs.push(`email-${i}`);
                } else if (!validate_email.test(nominee_data.contact_detail.email)) {
                    error_list[i].email_error = "Please provide valid email ID";
                    validation_status = false;
                    error_inputs.push(`email-${i}`);
                } else {
                    error_list[i].email_error = '';
                }

                // Address
                /// Address validation
                if (nominee_data.has_same_address === false) {
                    if (nominee_data.nominee_address.country === null) {
                        error_list[i].nationality_error = "Please provide country";
                        validation_status = false;
                        error_inputs.push(`nationality-${i}`);
                    } else {
                        error_list[i].nationality_error = "";
                    }

                    if (nominee_data.nominee_address.address_line1 === null) {
                        error_list[i].address_error = "Please provide address";
                        validation_status = false;
                        error_inputs.push(`address-${i}`);
                    } else {
                        error_list[i].address_error = "";
                    }

                    if (nominee_data.nominee_address.address_line2 === null) {
                        error_list[i].address2_error = "Please provide address";
                        validation_status = false;
                        error_inputs.push(`address2-${i}`);
                    } else {
                        error_list[i].address2_error = "";
                    }

                    if (nominee_data.nominee_address.state_name === null) {
                        error_list[i].state_error = "Please select state";
                        validation_status = false;
                        error_inputs.push(`state-${i}`);
                    } else {
                        error_list[i].state_error = "";
                    }

                    if (nominee_data.nominee_address.city === null) {
                        error_list[i].city_error = "Please select city";
                        validation_status = false;
                        error_inputs.push(`city-${i}`);
                    } else {
                        error_list[i].city_error = "";
                    }

                    if (nominee_data.nominee_address.pincode === null) {
                        error_list[i].pincode_error = "Please provide pincode";
                        validation_status = false;
                        error_inputs.push(`pincode-${i}`);
                    } else {
                        error_list[i].pincode_error = "";
                    }
                }
            }
        }

        setErrorMessage([...error_list]);

        // Scrolling to first error
        if (error_inputs.length !== 0) {
            let first_err_id = error_inputs[0];
            let element = document.getElementById(first_err_id);
            element.scrollIntoView({ behavior: "smooth" });
        } else {
            let totalAllocation = nomineeData.reduce((total, nominee) => total + nominee.allocation, 0);    // total allocation of nominees     
            if ((totalAllocation > 100 || totalAllocation < 100) && totalAllocation > 0) {
                toast.dismiss();
                toast.error("Total nominee allocation should be 100%");
                validation_status = false;
            }
        }

        return validation_status;
    };


    //nominee data
    const _handleNomineeData = (selected_nominee, index, selected_id_proof_id, selected_guardian_id_proof_id) => {

        let current_nominees = nomineeData;

        if (selected_nominee) {
            current_nominees[index] = selected_nominee;
            setNomineeData([...current_nominees]);
        }


        if (fetchNominee === true && index === current_nominees.length - 1) {
            const is_valid = _validateNomineeData(current_nominees, selected_id_proof_id, selected_guardian_id_proof_id); // pass data through param to avoid delay in useState 

            if (is_valid) {
                _addNominee(current_nominees);
            } else {
                setLoading(false);
            }
            setFetchNominee(false);
        }
    };

    //handle add more nominee
    const _handleAddMoreNominee = () => {
        if (nomineeData.length < 3) {
            const new_nominee = {
                "id": crypto.randomUUID(),
                "nominee_id": null,
                "name": null,
                "relation_id": null,
                "relation": null,
                "dob": null,
                "allocation": null,
                "guardian_name": null,
                "guardian_relationship_id": null,
                "guardian_relationship": null,
                "guardian_id_proof_type": null,
                "guardian_id_proof_number": null,
                "guardian_address": {
                    "address_line1": null,
                    "address_line2": null,
                    "state_id": null,
                    "state_name": null,
                    "city_id": null,
                    "city": null,
                    "pincode": null,
                    "country_id": null,
                    "country": null
                },
                "guardian_contact_detail": {
                    "email": null,
                    "country_code": null,
                    "phone_number": null
                },
                "identity_proof_type": null,
                "identity_proof_number": null,
                "nominee_address": {
                    "address_line1": null,
                    "address_line2": null,
                    "state_id": null,
                    "state_name": null,
                    "city_id": null,
                    "city": null,
                    "pincode": null,
                    "country_id": null,
                    "country": null,
                },
                "contact_detail": {
                    "email": null,
                    "country_code": null,
                    "phone_number": null
                },
                "nominations_info_visibility": true,
            };

            const new_error = {
                "id": crypto.randomUUID(),
                "name_error": null,
                "relation_id_error": null,
                "dob_error": null,
                "allocation_error": null,

                "id_proof_no_error": null,
                "selected_proof_id_error": null,
                "mobile_number_error": null,
                "email_error": null,

                "guardian_name_error": null,
                "guardian_relationship_id_error": null,
                "guardian_id_no_error": null,
                "guardian_mobile_number_error": null,
                "guardian_email_error": null,
                "guardian_id_type_error": null,

                "nationality_error": null,
                "address_error": null,
                "address_error2": null,
                "state_error": null,
                "city_error": null,
                "pincode_error": null
            };

            // Add a new nominee to the array
            // Update the nomineeData array with the new nominee
            setNomineeData([...nomineeData, new_nominee]);
            setErrorMessage([...errorMessage, new_error]);
        };
    };

    //handle add nominee submit
    const _handleSubmitAddNominee = () => {
        _trackEvent("nominee_submitted", { screen: "nominee_details", flow: "onboarding" });
        // Validate UI input fields
        setLoading(true);

        if (addNomineeSelect === 2) {
            _addNominee([]);

        } else {
            setFetchNominee(true);
        };
    };


    // Back to previous step -Onboarding
    const _handleBackToPrevious = () => {
        props.handleBack(props.kycUser ? 3 : 4);
    };

    // handle modal close
    const _handleModalClose = () => {
        // Closing modal
        var button = document.getElementById("kyc-status-modal-close-btn");
        button.click();

        setStatusModal(false);

        sessionStorage.removeItem('access_token');
        Cookies.remove('onboarding_refresh_token', { domain: process.env.REACT_APP_DOMAIN, path: '/', expires: 30 });
        Store.dispatch({
            type: 'UPDATE_ONBOARDING_TOKEN',
            payload:
                { refresh_token: null, access_token: null }
        });
        // enable navigation to Home page
        navigate("/", { replace: true, });
    };



    // ================================ //
    //============= API CALLS ========= //

    //API- Add nominee
    const _addNominee = (nominees) => {

        let nominee_data = nominees;

        // If nominee has same address as user, then update nominee address  as users permanent address 
        if (addNomineeSelect === 1) {
            nominee_data = nominee_data.map(nominee => {
                if (nominee.has_same_address) {
                    let is_minor_nominee = differenceInYears(new Date(), _formatDateFormat(nominee?.dob)) < 18;
                    nominee[is_minor_nominee ? "guardian_address" : "nominee_address"] = PROGRESS_DATA?.kyc_data?.address?.permanent_address || {};
                }
                return nominee;
            })
        };

        let api_version = 2;
        let is_post = true;
        let url = 'kyc/add-nominee';
        let data = {
            "nominee": nominee_data,
            "is_nominee_available": addNomineeSelect === 1 ? true : false,
            "nominations_info_visibility": nomineeVisibility,
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {

                _trackEvent("nominee_completed", { screen: "nominee_details", flow: "onboarding" });

                toast.dismiss();
                if (addNomineeSelect === 1) {
                    toast.success("Nominee added successfully", {
                        className: "e-toast",
                    });
                } else {
                    toast.success("Nominee details updated successfully", {
                        className: "e-toast",
                    });
                }


                if (PROGRESS_DATA.kyc_data.status === "KYC_REJECTED") {
                    // Just little delay for above toast message 
                    // setTimeout(() => {
                    //     setStatusModal(true);
                    // }, 500);

                    props.handleUpdateCurrentStep(props.kycUser ? 5 : 6); // 5 - Set Pin , 6 - ESign
                } else {
                    props.handleUpdateCurrentStep(props.kycUser ? 5 : 6); // 5 - Set Pin , 6 - ESign
                }


                // Update signup progress  data
                _getSignupProgress();

            } else {
                _trackEvent("nominee_failed", { screen: "nominee_details", flow: "onboarding", status_code: response.status_code, error_message: response.message });
                toast.dismiss();
                toast.error(response.message, {
                    className: "e-toast",
                });
            }
            setLoading(false);
        });
    };


    return (
        <div className="col-sm-10 col-xl-9 mx-auto px-sm-0">
            <div className="e-padding-block-40px-res padding-76px-top padding-150px-bottom position-relative">
                <div className={`${styles.e_onboarding_wrapper_personal_details} e-border-radius-24`}>
                    <div className="row flex-column flex-sm-row justify-content-between align-items-sm-center row-gap-2 margin-40px-bottom margin-24px-bottom-res">
                        <div className="col">
                            <div className="d-flex gap-3 gap-sm-4">
                                <Icon icon="arrow-back-left"
                                    className="cursor-pointer"
                                    size={24}
                                    onClick={_handleBackToPrevious} />
                                <h1 className="e-text-chinese-black  e-font-16-res e-font-20 e-alt-font-poppins e-font-weight-600 line-height-24px mb-0">
                                    Nominee Details
                                </h1>
                            </div>
                        </div>

                        <div className="col-10 col-sm-6 col-lg-4">
                            <div className="d-flex align-items-center gap-2">
                                <div className="flex-fill progress h-6 e-bg-lavender e-border-radius-16" role="progressbar" aria-label="Success example" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                                    <div className={`${props.kycUser ? "w-100" : "w-80per"} progress-bar progress-bar-bg w-100 e-border-radius-16`} ></div>
                                </div>
                                <p className='mb-0 e-text-egyptian-blue e-font-12 e-alt-font-poppins e-font-weight-500 line-height-24px'>
                                    Step {props.kycUser ? 3 : 4} of {props.kycUser ? 3 : 5}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Info message */}
                    <div className='d-flex align-items-start gap-2 e-bg-cornsilk e-border-radius-16 p-2 mt-4'>
                        <Icon icon="info"
                            size={"1rem"}
                            className="mt-1"
                            color={Colors.ochre} />
                        <span className='e-text-ochre e-alt-font-poppins e-font-12-res e-font-14 e-font-weight-400 line-height-24px'>
                            Adding a nominee ensures your chosen person will receive your assets, simplifying the transfer process when needed
                        </span>
                    </div>

                    {/* add nominee */}
                    <div className='pt-4'>
                        <h6 className='margin-12px-bottom e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-400'>
                            Do you want to add a nominee to your investment account?*
                        </h6>
                        <div className='d-flex e-gap-0-16'>
                            <RadioGroup data={YES_NO_OPTIONS}
                                selected={addNomineeSelect}
                                handleSelect={_handleAddNominee} />
                        </div>
                    </div>


                    {/* Nominee name */}
                    {/* nominee card */}
                    {
                        addNomineeSelect === 1 &&
                        <div className="">
                            {
                                nomineeData.length && nomineeData.map((data, key) => (
                                    <div className="onboarding-section-wrapper margin-top-32px" key={data.id}>
                                        {key !== 0 && (
                                            <div className='d-flex gap-4 align-items-center mb-4'>
                                                <h6 className='mb-0  e-text-charleston-green e-font-16 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                                                    Nominee {key + 1}
                                                </h6>
                                                <img src={Delete}
                                                    width={32}
                                                    height={32}
                                                    draggable={false}
                                                    className='cursor-pointer'
                                                    alt='delete'
                                                    onClick={() => _handleRemoveNominee(data.id)} />
                                            </div>
                                        )}
                                        <AddNomineeCard data={generalData}
                                            kycData={PROGRESS_DATA}
                                            index={key}
                                            countryData={countryData}
                                            nomineeData={data} // relation data
                                            error={errorMessage[key]}
                                            fetchNominee={fetchNominee}
                                            getNomineeData={_handleNomineeData} />
                                    </div>
                                ))
                            }

                            {/* nominee visibility */}
                            <div div className='mt-3'>
                                <h6 className='mb-2 e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-500 line-height-24px'>
                                    Nominee visibility on account statement*
                                </h6>
                                <div className='d-flex e-gap-0-16'>
                                    <RadioGroup data={generalData.nominations_info_visibility}
                                        selected={nomineeVisibility}
                                        fontSize={"e-font-14"}
                                        handleSelect={_handleChangeNomineeVisibility} />
                                </div>
                            </div>
                        </div>
                    }


                    <div className="row justify-content-end align-items-center margin-top-32px">
                        {
                            addNomineeSelect === 1 && nomineeData.length < 3 &&
                            <div className="col-auto">
                                <TextButton name="+ Add nominee" icon={false} type={2} onClick={_handleAddMoreNominee} />
                            </div>
                        }

                        <div className="col-5 col-sm-6 col-md-4 col-lg-4 ">
                            <PrimaryButton name={"Submit"}
                                loading={loading}
                                disabled={loading}
                                inActive={addNomineeSelect ? false : true}
                                className={`w-100 padding-12px-tb padding-8px-tb-res e-font-14`}
                                onPress={_handleSubmitAddNominee} />
                        </div>
                    </div>
                </div>
            </div>

            {/* kyc status modal  */}
            {
                statusModal === true &&
                <KycStatusModal title={"Almost Done"}
                    image={require("../../../Assets/Images/KYC/kyc-success.webp")}
                    description={"The KYC re submission  process has been initiated and the process will take 1-3 business days time. We will notify over mail once it is completed"}
                    onCloseModal={_handleModalClose}
                    buttonName={"Understood"}
                    onButtonClick={_handleModalClose}
                />
            }
        </div >
    )
}

export default AddNominee;